const ivroptioncsvcolumndata = [
  { id: "digits", title: "Digit", default: true },
  { id: "description", title: "Description", default: true },
  { id: "destination", title: "Destination", default: true },
];
export default ivroptioncsvcolumndata;
